import { OfferingType } from '../enums/offering-type.enum';

export const OFFERING_TYPE_ROUTE: Record<string, string> = {
  [OfferingType.APPLICATION]: 'application',
  [OfferingType.PLATFORM]: 'platform',
  [OfferingType.SOLUTION]: 'solution',
  [OfferingType.PROFESSIONAL_SERVICE]: 'professional-service',
  [OfferingType.INFRASTRUCTURE]: 'infrastructure',
};
